"use strict";
exports.__esModule = true;
exports.Url = exports.UrlValue = void 0;
var UrlValue;
(function (UrlValue) {
    UrlValue["S"] = "fusionId";
})(UrlValue = exports.UrlValue || (exports.UrlValue = {}));
var decodeUrl = function (url) { return decodeURIComponent(url); };
var getParamsInQueryString = function () {
    var search = location.search.substring(1);
    var paramsDecoded = decodeUrl(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"');
    var validFusionIdParams = paramsDecoded.includes('fusionId');
    return validFusionIdParams ? JSON.parse("{\"" + paramsDecoded + "\"}") : {};
};
// todo polyfill IE11 URL & URLSearchParams
var setParamInQueryString = function (key, value) {
    var _a;
    var url = new URL(location.href);
    var searchParams = new URLSearchParams(url.search);
    searchParams.set(key, value);
    url.search = searchParams.toString();
    url.toString();
    history.replaceState((_a = {}, _a[key] = value, _a), '', url.search);
};
exports.Url = { getParamsInQueryString: getParamsInQueryString, setParamInQueryString: setParamInQueryString };
//# sourceMappingURL=url.js.map